import {byId} from './util';

const initialState = {
  byId: {},
  currentInviteId: null
};

function fixInvite(invite) {
  return Object.assign({}, invite, {invite_id: invite.invite_id_hash});
}

export function invites(state = initialState, action) {
  switch (action.type) {
  case 'INVITE_RECEIVE': {
    const fixedInvite = fixInvite(action.payload);
    const newState = byId(state, fixedInvite, 'invite_id');
    newState.currentInviteId = fixedInvite.invite_id;
    return newState;
  }
  default:
    return state;
  }
}
